import { DataTable, FormSectionHeader, Heading, Loader } from "@/components";
import useReconciliationReport from "./useReconciliationReport";
import { Card, CardContent, CardHeader, Input } from "@/components/ui";
import { cn } from "@/lib/utils";
import { Search } from "lucide-react";

const ReconciliationReport = () => {
  const {breadcrumbData, isLoadingReportData, summaryCards, columns, globalFilter, setGlobalFilter, reportData, currentFinanceYear} = useReconciliationReport();

  return (
    <div className="p-4">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={<span>Cost Analytics Reconciliation Report <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>} breadcrumbData={breadcrumbData} />
      </div>

      {isLoadingReportData ? <Loader /> : 
        <>
          <Card className="mb-6">
            <CardContent>
              <span className="font-medium text-[14px] text-gray-400">Full lineage from the originating journal entry line to every final receiver, with per-source-line balancing so no value is lost or double-counted. Critical for audit.</span>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-[20px] mt-5">
                {summaryCards?.map((data: any) => {
                  return (
                    <Card className={cn("shadow-none", data?.className ? data?.className : data?.isBalanced ? "bg-green-50" : "bg-red-50")} key={data?.id}>
                      <CardContent className="font-medium text-gray-400 text-[14px] flex flex-col items-center justify-center">
                        <label>{data?.title}</label>
                        <span className="text-[20px] text-black">{data?.amt || data?.text || ""}</span>
                        <label className="text-center">{data?.desc}</label>
                      </CardContent>
                    </Card>
                  )
                })}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-col md:flex-row md:items-center md:justify-between">
              <FormSectionHeader>Full Lineage</FormSectionHeader>
              <div>
                <Input
                  type="text"
                  placeholder="Search by Doc Number, sender, or receiver..."
                  value={globalFilter ?? ""}
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  className="w-full sm:w-72 bg-white h-[40px]"
                  startIcon={<Search className="w-4 h-4" />}
                />
              </div>
            </CardHeader>
            <CardContent>
              <DataTable
                columns={columns}
                data={reportData?.rows || []}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
              />
            </CardContent>
          </Card>
        </>
      }
    </div>
  )
}

export default ReconciliationReport;